module.exports = __webpack_public_path__ + "img/icon-indian.a236667e.svg";